import { AGENCY_TYPE, AgencyKeys, Goal, GoalKeys } from '@ag-common-lib/public-api';
import { BaseModelKeys } from '@ag-common-lib/lib/models/base.model';
import { MgaWithGoalsListItemResponse } from '@ag-common-lib/lib/contracts/reporting-api/response/mga-sales-goals';
import {
  getYearGoalField,
  getYearProductionField,
  MGA_SALES_GOALS_GROUP_FIELD,
  MGA_SALES_GOALS_MGA_GROUP,
  MGA_SALES_GOALS_PLACEHOLDER_GROUP,
  MgaSalesGoalYearCell,
  MgaSalesGoalsGridRow,
  MgaSalesGoalsPlaceholder,
} from './mga-sales-goals.model';

export const mapMgaWithGoalsListItemToGridRow = (
  item: MgaWithGoalsListItemResponse,
  gridYears: number[],
): MgaSalesGoalsGridRow => {
  const yearCells: Record<number, MgaSalesGoalYearCell> = {};
  const goals: Goal[] = [];

  gridYears.forEach(year => {
    const goalAmount = item[getYearGoalField(year)] ?? null;
    const production = item[getYearProductionField(year)] ?? null;

    yearCells[year] = {
      year,
      goalAmount,
      production,
      // Only meaningful against a goal; without one there is nothing to be a percentage of.
      percentOfGoal:
        goalAmount != null && goalAmount > 0 && production != null ? (production / goalAmount) * 100 : null,
    };

    if (goalAmount != null) {
      goals.push({
        [GoalKeys.year]: year,
        [GoalKeys.amount]: goalAmount,
      });
    }
  });

  const row: MgaSalesGoalsGridRow = {
    key: item.agencyPlatformId,
    [BaseModelKeys.dbId]: item.agencyPlatformId,
    [AgencyKeys.name]: item.name,
    [AgencyKeys.agencyId]: item.agencyPlatformId,
    [AgencyKeys.agencyType]: item.type as AGENCY_TYPE,
    [AgencyKeys.mga_goals]: goals,
    [MGA_SALES_GOALS_GROUP_FIELD]: MGA_SALES_GOALS_MGA_GROUP,
    yearCells,
  };

  gridYears.forEach(year => {
    row[getYearGoalField(year)] = yearCells[year].goalAmount;
  });

  return row;
};

export const mapPlaceholderToGridRow = (
  placeholder: MgaSalesGoalsPlaceholder,
  gridYears: readonly number[],
): MgaSalesGoalsGridRow => {
  const yearCells: Record<number, MgaSalesGoalYearCell> = {};
  const row: MgaSalesGoalsGridRow = {
    key: placeholder.key,
    [BaseModelKeys.dbId]: placeholder.key,
    [AgencyKeys.name]: placeholder.name,
    [AgencyKeys.agencyId]: '',
    [AgencyKeys.mga_goals]: placeholder.goals,
    [MGA_SALES_GOALS_GROUP_FIELD]: MGA_SALES_GOALS_PLACEHOLDER_GROUP,
    yearCells,
  };

  gridYears.forEach(year => {
    const goal = placeholder.goals.find(item => Number(item[GoalKeys.year]) === year);
    const goalAmount = goal?.[GoalKeys.amount] ?? null;

    yearCells[year] = {
      year,
      goalAmount,
      production: null,
      percentOfGoal: null,
    };
    row[getYearGoalField(year)] = goalAmount;
  });

  return row;
};
